/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CouponDefinitionDTO } from '../dto';
// @ts-ignore
import type { CouponDefinitionListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2GiftDTO } from '../dto';
// @ts-ignore
import type { CouponsV2GiftListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2GiftWithEmployeeListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2OrderStatus } from '../dto';
// @ts-ignore
import type { CouponsV2TokenOrderDTO } from '../dto';
// @ts-ignore
import type { CouponsV2TokenOrderListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2UserOrderDTO } from '../dto';
// @ts-ignore
import type { CouponsV2UserOrderListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2UserOrderWithUserListDTO } from '../dto';
// @ts-ignore
import type { CouponsV2UserTokenDTO } from '../dto';
// @ts-ignore
import type { CouponsV2UserTokenListDTO } from '../dto';
// @ts-ignore
import type { CreateCouponsV2GiftDTO } from '../dto';
// @ts-ignore
import type { IdentifierDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponsV2GiftDTO } from '../dto';
// @ts-ignore
import type { UpdateCouponsV2UserOrderDTO } from '../dto';
// @ts-ignore
import type { ValidationErrorResponseDTO } from '../dto';
/**
 * CouponsV2Api - axios parameter creator
 * @export
 */
export const CouponsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary cancels a pending token order
         * @param {string} tenantId 
         * @param {string} couponsV2TokenOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTokenOrder: async (tenantId: string, couponsV2TokenOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('cancelTokenOrder', 'tenantId', tenantId)
            // verify required parameter 'couponsV2TokenOrderId' is not null or undefined
            assertParamExists('cancelTokenOrder', 'couponsV2TokenOrderId', couponsV2TokenOrderId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons_v2/tokenOrders/{couponsV2TokenOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"couponsV2TokenOrderId"}}`, encodeURIComponent(String(couponsV2TokenOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary cancels a pending coupon user order
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUserOrder: async (userId: string, userOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('cancelUserOrder', 'userId', userId)
            // verify required parameter 'userOrderId' is not null or undefined
            assertParamExists('cancelUserOrder', 'userOrderId', userOrderId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userOrders/{userOrderId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userOrderId"}}`, encodeURIComponent(String(userOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary claims the gift for an employee and assigns it to the user
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimCouponGift: async (tenantId: string, employeeId: string, couponsV2GiftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('claimCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('claimCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponsV2GiftId' is not null or undefined
            assertParamExists('claimCouponGift', 'couponsV2GiftId', couponsV2GiftId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts/{couponsV2GiftId}/claim`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponsV2GiftId"}}`, encodeURIComponent(String(couponsV2GiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponsV2GiftDTO} createCouponsV2GiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponGift: async (tenantId: string, employeeId: string, createCouponsV2GiftDTO: CreateCouponsV2GiftDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createCouponGift', 'employeeId', employeeId)
            // verify required parameter 'createCouponsV2GiftDTO' is not null or undefined
            assertParamExists('createCouponGift', 'createCouponsV2GiftDTO', createCouponsV2GiftDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponsV2GiftDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouponGift: async (tenantId: string, employeeId: string, couponsV2GiftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponsV2GiftId' is not null or undefined
            assertParamExists('deleteCouponGift', 'couponsV2GiftId', couponsV2GiftId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts/{couponsV2GiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponsV2GiftId"}}`, encodeURIComponent(String(couponsV2GiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {ExportTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ExportTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ExportTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTokenOrders: async (tenantId: string, month?: string, orderReason?: ExportTokenOrdersOrderReasonEnum, giftType?: ExportTokenOrdersGiftTypeEnum, status?: Array<ExportTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportTokenOrders', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons_v2/tokenOrders/export/csv`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (orderReason !== undefined) {
                localVarQueryParameter['orderReason'] = orderReason;
            }

            if (giftType !== undefined) {
                localVarQueryParameter['giftType'] = giftType;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (deletedOnly !== undefined) {
                localVarQueryParameter['deletedOnly'] = deletedOnly;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupons available to user
         * @param {string} userId 
         * @param {boolean} [includeVariations] 
         * @param {number} [variation] 
         * @param {Array<number>} [variations] 
         * @param {string} [category] 
         * @param {boolean} [includeCombinations] 
         * @param {boolean} [isFallback] 
         * @param {boolean} [isFlexFallback] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserCouponDefinitions: async (userId: string, includeVariations?: boolean, variation?: number, variations?: Array<number>, category?: string, includeCombinations?: boolean, isFallback?: boolean, isFlexFallback?: boolean, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('findUserCouponDefinitions', 'userId', userId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/definitions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (includeVariations !== undefined) {
                localVarQueryParameter['includeVariations'] = includeVariations;
            }

            if (variation !== undefined) {
                localVarQueryParameter['variation'] = variation;
            }

            if (variations) {
                localVarQueryParameter['variations'] = variations;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (includeCombinations !== undefined) {
                localVarQueryParameter['includeCombinations'] = includeCombinations;
            }

            if (isFallback !== undefined) {
                localVarQueryParameter['isFallback'] = isFallback;
            }

            if (isFlexFallback !== undefined) {
                localVarQueryParameter['isFlexFallback'] = isFlexFallback;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponGift: async (tenantId: string, employeeId: string, couponsV2GiftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponsV2GiftId' is not null or undefined
            assertParamExists('getCouponGift', 'couponsV2GiftId', couponsV2GiftId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts/{couponsV2GiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponsV2GiftId"}}`, encodeURIComponent(String(couponsV2GiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a single token order by id
         * @param {string} tenantId 
         * @param {string} couponsV2TokenOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenOrder: async (tenantId: string, couponsV2TokenOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTokenOrder', 'tenantId', tenantId)
            // verify required parameter 'couponsV2TokenOrderId' is not null or undefined
            assertParamExists('getTokenOrder', 'couponsV2TokenOrderId', couponsV2TokenOrderId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons_v2/tokenOrders/{couponsV2TokenOrderId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"couponsV2TokenOrderId"}}`, encodeURIComponent(String(couponsV2TokenOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon definition for the user
         * @param {string} userId 
         * @param {string} couponDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCouponDefinition: async (userId: string, couponDefinitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCouponDefinition', 'userId', userId)
            // verify required parameter 'couponDefinitionId' is not null or undefined
            assertParamExists('getUserCouponDefinition', 'couponDefinitionId', couponDefinitionId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/definitions/{couponDefinitionId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"couponDefinitionId"}}`, encodeURIComponent(String(couponDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single coupon user order by id
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrder: async (userId: string, userOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserOrder', 'userId', userId)
            // verify required parameter 'userOrderId' is not null or undefined
            assertParamExists('getUserOrder', 'userOrderId', userOrderId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userOrders/{userOrderId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userOrderId"}}`, encodeURIComponent(String(userOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns a single user token by id
         * @param {string} userId 
         * @param {string} userTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserToken: async (userId: string, userTokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserToken', 'userId', userId)
            // verify required parameter 'userTokenId' is not null or undefined
            assertParamExists('getUserToken', 'userTokenId', userTokenId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userTokens/{userTokenId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userTokenId"}}`, encodeURIComponent(String(userTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all coupon orders for all users
         * @param {Array<CouponsV2OrderStatus>} [status] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrders: async (status?: Array<CouponsV2OrderStatus>, filter?: string, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/coupons_v2/userOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {string} [month] 
         * @param {ListAllTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ListAllTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ListAllTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllTokenOrders: async (month?: string, orderReason?: ListAllTokenOrdersOrderReasonEnum, giftType?: ListAllTokenOrdersGiftTypeEnum, status?: Array<ListAllTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/coupons_v2/tokenOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (orderReason !== undefined) {
                localVarQueryParameter['orderReason'] = orderReason;
            }

            if (giftType !== undefined) {
                localVarQueryParameter['giftType'] = giftType;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (deletedOnly !== undefined) {
                localVarQueryParameter['deletedOnly'] = deletedOnly;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponGifts: async (tenantId: string, employeeId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listCouponGifts', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('listCouponGifts', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [isDelivered] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenantCouponGifts: async (tenantId: string, filter?: string, isDelivered?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listTenantCouponGifts', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons_v2/gifts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (isDelivered !== undefined) {
                localVarQueryParameter['isDelivered'] = isDelivered;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns token orders for tenant
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {ListTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ListTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ListTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTokenOrders: async (tenantId: string, month?: string, orderReason?: ListTokenOrdersOrderReasonEnum, giftType?: ListTokenOrdersGiftTypeEnum, status?: Array<ListTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listTokenOrders', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/coupons_v2/tokenOrders`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (orderReason !== undefined) {
                localVarQueryParameter['orderReason'] = orderReason;
            }

            if (giftType !== undefined) {
                localVarQueryParameter['giftType'] = giftType;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (deletedOnly !== undefined) {
                localVarQueryParameter['deletedOnly'] = deletedOnly;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns coupon orders for user
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrders: async (userId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserOrders', 'userId', userId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userOrders`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns tokens for user
         * @param {string} userId 
         * @param {boolean} [isRedeemed] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTokens: async (userId: string, isRedeemed?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserTokens', 'userId', userId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userTokens`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (isRedeemed !== undefined) {
                localVarQueryParameter['isRedeemed'] = isRedeemed;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCouponCodeToHasBeenSeen: async (userId: string, userOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setCouponCodeToHasBeenSeen', 'userId', userId)
            // verify required parameter 'userOrderId' is not null or undefined
            assertParamExists('setCouponCodeToHasBeenSeen', 'userOrderId', userOrderId)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userOrders/orderView/{userOrderId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userOrderId"}}`, encodeURIComponent(String(userOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {UpdateCouponsV2GiftDTO} updateCouponsV2GiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponGift: async (tenantId: string, employeeId: string, couponsV2GiftId: string, updateCouponsV2GiftDTO: UpdateCouponsV2GiftDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCouponGift', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateCouponGift', 'employeeId', employeeId)
            // verify required parameter 'couponsV2GiftId' is not null or undefined
            assertParamExists('updateCouponGift', 'couponsV2GiftId', couponsV2GiftId)
            // verify required parameter 'updateCouponsV2GiftDTO' is not null or undefined
            assertParamExists('updateCouponGift', 'updateCouponsV2GiftDTO', updateCouponsV2GiftDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/coupons_v2/gifts/{couponsV2GiftId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"couponsV2GiftId"}}`, encodeURIComponent(String(couponsV2GiftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponsV2GiftDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a coupon order for user
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {UpdateCouponsV2UserOrderDTO} updateCouponsV2UserOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrder: async (userId: string, userOrderId: string, updateCouponsV2UserOrderDTO: UpdateCouponsV2UserOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserOrder', 'userId', userId)
            // verify required parameter 'userOrderId' is not null or undefined
            assertParamExists('updateUserOrder', 'userOrderId', userOrderId)
            // verify required parameter 'updateCouponsV2UserOrderDTO' is not null or undefined
            assertParamExists('updateUserOrder', 'updateCouponsV2UserOrderDTO', updateCouponsV2UserOrderDTO)
            const localVarPath = `/users/{userId}/benefits/coupons_v2/userOrders/{userOrderId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"userOrderId"}}`, encodeURIComponent(String(userOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponsV2UserOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponsV2Api - functional programming interface
 * @export
 */
export const CouponsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary cancels a pending token order
         * @param {string} tenantId 
         * @param {string} couponsV2TokenOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTokenOrder(tenantId: string, couponsV2TokenOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTokenOrder(tenantId, couponsV2TokenOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.cancelTokenOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary cancels a pending coupon user order
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelUserOrder(userId: string, userOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelUserOrder(userId, userOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.cancelUserOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary claims the gift for an employee and assigns it to the user
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimCouponGift(tenantId: string, employeeId: string, couponsV2GiftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimCouponGift(tenantId, employeeId, couponsV2GiftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.claimCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {CreateCouponsV2GiftDTO} createCouponsV2GiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouponGift(tenantId: string, employeeId: string, createCouponsV2GiftDTO: CreateCouponsV2GiftDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouponGift(tenantId, employeeId, createCouponsV2GiftDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.createCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCouponGift(tenantId: string, employeeId: string, couponsV2GiftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCouponGift(tenantId, employeeId, couponsV2GiftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.deleteCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {ExportTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ExportTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ExportTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTokenOrders(tenantId: string, month?: string, orderReason?: ExportTokenOrdersOrderReasonEnum, giftType?: ExportTokenOrdersGiftTypeEnum, status?: Array<ExportTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTokenOrders(tenantId, month, orderReason, giftType, status, filter, withAggregations, deletedOnly, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.exportTokenOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupons available to user
         * @param {string} userId 
         * @param {boolean} [includeVariations] 
         * @param {number} [variation] 
         * @param {Array<number>} [variations] 
         * @param {string} [category] 
         * @param {boolean} [includeCombinations] 
         * @param {boolean} [isFallback] 
         * @param {boolean} [isFlexFallback] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUserCouponDefinitions(userId: string, includeVariations?: boolean, variation?: number, variations?: Array<number>, category?: string, includeCombinations?: boolean, isFallback?: boolean, isFlexFallback?: boolean, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDefinitionListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUserCouponDefinitions(userId, includeVariations, variation, variations, category, includeCombinations, isFallback, isFlexFallback, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.findUserCouponDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponGift(tenantId: string, employeeId: string, couponsV2GiftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2GiftDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponGift(tenantId, employeeId, couponsV2GiftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.getCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a single token order by id
         * @param {string} tenantId 
         * @param {string} couponsV2TokenOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenOrder(tenantId: string, couponsV2TokenOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2TokenOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenOrder(tenantId, couponsV2TokenOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.getTokenOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon definition for the user
         * @param {string} userId 
         * @param {string} couponDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCouponDefinition(userId: string, couponDefinitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDefinitionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCouponDefinition(userId, couponDefinitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.getUserCouponDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single coupon user order by id
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserOrder(userId: string, userOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2UserOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserOrder(userId, userOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.getUserOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns a single user token by id
         * @param {string} userId 
         * @param {string} userTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserToken(userId: string, userTokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2UserTokenDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserToken(userId, userTokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.getUserToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all coupon orders for all users
         * @param {Array<CouponsV2OrderStatus>} [status] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllOrders(status?: Array<CouponsV2OrderStatus>, filter?: string, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2UserOrderWithUserListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllOrders(status, filter, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listAllOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {string} [month] 
         * @param {ListAllTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ListAllTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ListAllTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllTokenOrders(month?: string, orderReason?: ListAllTokenOrdersOrderReasonEnum, giftType?: ListAllTokenOrdersGiftTypeEnum, status?: Array<ListAllTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2TokenOrderListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllTokenOrders(month, orderReason, giftType, status, filter, withAggregations, deletedOnly, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listAllTokenOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCouponGifts(tenantId: string, employeeId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2GiftListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCouponGifts(tenantId, employeeId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listCouponGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [isDelivered] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTenantCouponGifts(tenantId: string, filter?: string, isDelivered?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2GiftWithEmployeeListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTenantCouponGifts(tenantId, filter, isDelivered, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listTenantCouponGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns token orders for tenant
         * @param {string} tenantId 
         * @param {string} [month] 
         * @param {ListTokenOrdersOrderReasonEnum} [orderReason] 
         * @param {ListTokenOrdersGiftTypeEnum} [giftType] 
         * @param {Array<ListTokenOrdersStatusEnum>} [status] 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {boolean} [deletedOnly] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTokenOrders(tenantId: string, month?: string, orderReason?: ListTokenOrdersOrderReasonEnum, giftType?: ListTokenOrdersGiftTypeEnum, status?: Array<ListTokenOrdersStatusEnum>, filter?: string, withAggregations?: boolean, deletedOnly?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2TokenOrderListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTokenOrders(tenantId, month, orderReason, giftType, status, filter, withAggregations, deletedOnly, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listTokenOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns coupon orders for user
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserOrders(userId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2UserOrderListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserOrders(userId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listUserOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns tokens for user
         * @param {string} userId 
         * @param {boolean} [isRedeemed] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserTokens(userId: string, isRedeemed?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponsV2UserTokenListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserTokens(userId, isRedeemed, page, pageSize, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.listUserTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCouponCodeToHasBeenSeen(userId: string, userOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCouponCodeToHasBeenSeen(userId, userOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.setCouponCodeToHasBeenSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} couponsV2GiftId 
         * @param {UpdateCouponsV2GiftDTO} updateCouponsV2GiftDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouponGift(tenantId: string, employeeId: string, couponsV2GiftId: string, updateCouponsV2GiftDTO: UpdateCouponsV2GiftDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouponGift(tenantId, employeeId, couponsV2GiftId, updateCouponsV2GiftDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.updateCouponGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updates a coupon order for user
         * @param {string} userId 
         * @param {string} userOrderId 
         * @param {UpdateCouponsV2UserOrderDTO} updateCouponsV2UserOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrder(userId: string, userOrderId: string, updateCouponsV2UserOrderDTO: UpdateCouponsV2UserOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrder(userId, userOrderId, updateCouponsV2UserOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsV2Api.updateUserOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouponsV2Api - factory interface
 * @export
 */
export const CouponsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponsV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary cancels a pending token order
         * @param {CouponsV2ApiCancelTokenOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTokenOrder(requestParameters: CouponsV2ApiCancelTokenOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelTokenOrder(requestParameters.tenantId, requestParameters.couponsV2TokenOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary cancels a pending coupon user order
         * @param {CouponsV2ApiCancelUserOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUserOrder(requestParameters: CouponsV2ApiCancelUserOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelUserOrder(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary claims the gift for an employee and assigns it to the user
         * @param {CouponsV2ApiClaimCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimCouponGift(requestParameters: CouponsV2ApiClaimCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.claimCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates a coupon gift for employee
         * @param {CouponsV2ApiCreateCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouponGift(requestParameters: CouponsV2ApiCreateCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdentifierDTO> {
            return localVarFp.createCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponsV2GiftDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deletes a coupon gift for employee
         * @param {CouponsV2ApiDeleteCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouponGift(requestParameters: CouponsV2ApiDeleteCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns the whole transaction history list in CSV format
         * @param {CouponsV2ApiExportTokenOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTokenOrders(requestParameters: CouponsV2ApiExportTokenOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportTokenOrders(requestParameters.tenantId, requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupons available to user
         * @param {CouponsV2ApiFindUserCouponDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserCouponDefinitions(requestParameters: CouponsV2ApiFindUserCouponDefinitionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponDefinitionListDTO> {
            return localVarFp.findUserCouponDefinitions(requestParameters.userId, requestParameters.includeVariations, requestParameters.variation, requestParameters.variations, requestParameters.category, requestParameters.includeCombinations, requestParameters.isFallback, requestParameters.isFlexFallback, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon gift by id
         * @param {CouponsV2ApiGetCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponGift(requestParameters: CouponsV2ApiGetCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2GiftDTO> {
            return localVarFp.getCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a single token order by id
         * @param {CouponsV2ApiGetTokenOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenOrder(requestParameters: CouponsV2ApiGetTokenOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2TokenOrderDTO> {
            return localVarFp.getTokenOrder(requestParameters.tenantId, requestParameters.couponsV2TokenOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon definition for the user
         * @param {CouponsV2ApiGetUserCouponDefinitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCouponDefinition(requestParameters: CouponsV2ApiGetUserCouponDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponDefinitionDTO> {
            return localVarFp.getUserCouponDefinition(requestParameters.userId, requestParameters.couponDefinitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single coupon user order by id
         * @param {CouponsV2ApiGetUserOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrder(requestParameters: CouponsV2ApiGetUserOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2UserOrderDTO> {
            return localVarFp.getUserOrder(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns a single user token by id
         * @param {CouponsV2ApiGetUserTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserToken(requestParameters: CouponsV2ApiGetUserTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2UserTokenDTO> {
            return localVarFp.getUserToken(requestParameters.userId, requestParameters.userTokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all coupon orders for all users
         * @param {CouponsV2ApiListAllOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrders(requestParameters: CouponsV2ApiListAllOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2UserOrderWithUserListDTO> {
            return localVarFp.listAllOrders(requestParameters.status, requestParameters.filter, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all budget orders for all tenants
         * @param {CouponsV2ApiListAllTokenOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllTokenOrders(requestParameters: CouponsV2ApiListAllTokenOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2TokenOrderListDTO> {
            return localVarFp.listAllTokenOrders(requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon gifts for employee
         * @param {CouponsV2ApiListCouponGiftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCouponGifts(requestParameters: CouponsV2ApiListCouponGiftsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2GiftListDTO> {
            return localVarFp.listCouponGifts(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon gifts for tenant
         * @param {CouponsV2ApiListTenantCouponGiftsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenantCouponGifts(requestParameters: CouponsV2ApiListTenantCouponGiftsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2GiftWithEmployeeListDTO> {
            return localVarFp.listTenantCouponGifts(requestParameters.tenantId, requestParameters.filter, requestParameters.isDelivered, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns token orders for tenant
         * @param {CouponsV2ApiListTokenOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTokenOrders(requestParameters: CouponsV2ApiListTokenOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2TokenOrderListDTO> {
            return localVarFp.listTokenOrders(requestParameters.tenantId, requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns coupon orders for user
         * @param {CouponsV2ApiListUserOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrders(requestParameters: CouponsV2ApiListUserOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2UserOrderListDTO> {
            return localVarFp.listUserOrders(requestParameters.userId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns tokens for user
         * @param {CouponsV2ApiListUserTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTokens(requestParameters: CouponsV2ApiListUserTokensRequest, options?: RawAxiosRequestConfig): AxiosPromise<CouponsV2UserTokenListDTO> {
            return localVarFp.listUserTokens(requestParameters.userId, requestParameters.isRedeemed, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sets coupon code to seen
         * @param {CouponsV2ApiSetCouponCodeToHasBeenSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCouponCodeToHasBeenSeen(requestParameters: CouponsV2ApiSetCouponCodeToHasBeenSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCouponCodeToHasBeenSeen(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a coupon gift for employee
         * @param {CouponsV2ApiUpdateCouponGiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouponGift(requestParameters: CouponsV2ApiUpdateCouponGiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, requestParameters.updateCouponsV2GiftDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a coupon order for user
         * @param {CouponsV2ApiUpdateUserOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrder(requestParameters: CouponsV2ApiUpdateUserOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserOrder(requestParameters.userId, requestParameters.userOrderId, requestParameters.updateCouponsV2UserOrderDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelTokenOrder operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiCancelTokenOrderRequest
 */
export interface CouponsV2ApiCancelTokenOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCancelTokenOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCancelTokenOrder
     */
    readonly couponsV2TokenOrderId: string
}

/**
 * Request parameters for cancelUserOrder operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiCancelUserOrderRequest
 */
export interface CouponsV2ApiCancelUserOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCancelUserOrder
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCancelUserOrder
     */
    readonly userOrderId: string
}

/**
 * Request parameters for claimCouponGift operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiClaimCouponGiftRequest
 */
export interface CouponsV2ApiClaimCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiClaimCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiClaimCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiClaimCouponGift
     */
    readonly couponsV2GiftId: string
}

/**
 * Request parameters for createCouponGift operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiCreateCouponGiftRequest
 */
export interface CouponsV2ApiCreateCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCreateCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiCreateCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {CreateCouponsV2GiftDTO}
     * @memberof CouponsV2ApiCreateCouponGift
     */
    readonly createCouponsV2GiftDTO: CreateCouponsV2GiftDTO
}

/**
 * Request parameters for deleteCouponGift operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiDeleteCouponGiftRequest
 */
export interface CouponsV2ApiDeleteCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiDeleteCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiDeleteCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiDeleteCouponGift
     */
    readonly couponsV2GiftId: string
}

/**
 * Request parameters for exportTokenOrders operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiExportTokenOrdersRequest
 */
export interface CouponsV2ApiExportTokenOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly month?: string

    /**
     * 
     * @type {'BENEFIT_ACTIVATION' | 'GIFT'}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly orderReason?: ExportTokenOrdersOrderReasonEnum

    /**
     * 
     * @type {'GIFT' | 'INCENTIVE'}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly giftType?: ExportTokenOrdersGiftTypeEnum

    /**
     * 
     * @type {Array<'INITIAL' | 'INVOICE_CREATED' | 'PAID' | 'AVAILABLE' | 'DELIVERED' | 'PAYMENT_FAILED' | 'PENDING_REFUND' | 'CANCELLED'>}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly status?: Array<ExportTokenOrdersStatusEnum>

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly deletedOnly?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiExportTokenOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for findUserCouponDefinitions operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiFindUserCouponDefinitionsRequest
 */
export interface CouponsV2ApiFindUserCouponDefinitionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly userId: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly includeVariations?: boolean

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly variation?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly variations?: Array<number>

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly category?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly includeCombinations?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly isFallback?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly isFlexFallback?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiFindUserCouponDefinitions
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getCouponGift operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiGetCouponGiftRequest
 */
export interface CouponsV2ApiGetCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetCouponGift
     */
    readonly couponsV2GiftId: string
}

/**
 * Request parameters for getTokenOrder operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiGetTokenOrderRequest
 */
export interface CouponsV2ApiGetTokenOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetTokenOrder
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetTokenOrder
     */
    readonly couponsV2TokenOrderId: string
}

/**
 * Request parameters for getUserCouponDefinition operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiGetUserCouponDefinitionRequest
 */
export interface CouponsV2ApiGetUserCouponDefinitionRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserCouponDefinition
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserCouponDefinition
     */
    readonly couponDefinitionId: string
}

/**
 * Request parameters for getUserOrder operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiGetUserOrderRequest
 */
export interface CouponsV2ApiGetUserOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserOrder
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserOrder
     */
    readonly userOrderId: string
}

/**
 * Request parameters for getUserToken operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiGetUserTokenRequest
 */
export interface CouponsV2ApiGetUserTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserToken
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiGetUserToken
     */
    readonly userTokenId: string
}

/**
 * Request parameters for listAllOrders operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListAllOrdersRequest
 */
export interface CouponsV2ApiListAllOrdersRequest {
    /**
     * 
     * @type {Array<CouponsV2OrderStatus>}
     * @memberof CouponsV2ApiListAllOrders
     */
    readonly status?: Array<CouponsV2OrderStatus>

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListAllOrders
     */
    readonly filter?: string

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListAllOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListAllOrders
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiListAllOrders
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for listAllTokenOrders operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListAllTokenOrdersRequest
 */
export interface CouponsV2ApiListAllTokenOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly month?: string

    /**
     * 
     * @type {'BENEFIT_ACTIVATION' | 'GIFT'}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly orderReason?: ListAllTokenOrdersOrderReasonEnum

    /**
     * 
     * @type {'GIFT' | 'INCENTIVE'}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly giftType?: ListAllTokenOrdersGiftTypeEnum

    /**
     * 
     * @type {Array<'INITIAL' | 'INVOICE_CREATED' | 'PAID' | 'AVAILABLE' | 'DELIVERED' | 'PAYMENT_FAILED' | 'PENDING_REFUND' | 'CANCELLED'>}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly status?: Array<ListAllTokenOrdersStatusEnum>

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly deletedOnly?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListAllTokenOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listCouponGifts operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListCouponGiftsRequest
 */
export interface CouponsV2ApiListCouponGiftsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListCouponGifts
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListCouponGifts
     */
    readonly employeeId: string

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListCouponGifts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListCouponGifts
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listTenantCouponGifts operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListTenantCouponGiftsRequest
 */
export interface CouponsV2ApiListTenantCouponGiftsRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly isDelivered?: boolean

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiListTenantCouponGifts
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for listTokenOrders operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListTokenOrdersRequest
 */
export interface CouponsV2ApiListTokenOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly month?: string

    /**
     * 
     * @type {'BENEFIT_ACTIVATION' | 'GIFT'}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly orderReason?: ListTokenOrdersOrderReasonEnum

    /**
     * 
     * @type {'GIFT' | 'INCENTIVE'}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly giftType?: ListTokenOrdersGiftTypeEnum

    /**
     * 
     * @type {Array<'INITIAL' | 'INVOICE_CREATED' | 'PAID' | 'AVAILABLE' | 'DELIVERED' | 'PAYMENT_FAILED' | 'PENDING_REFUND' | 'CANCELLED'>}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly status?: Array<ListTokenOrdersStatusEnum>

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly deletedOnly?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListTokenOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listUserOrders operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListUserOrdersRequest
 */
export interface CouponsV2ApiListUserOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListUserOrders
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListUserOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListUserOrders
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listUserTokens operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiListUserTokensRequest
 */
export interface CouponsV2ApiListUserTokensRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiListUserTokens
     */
    readonly userId: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponsV2ApiListUserTokens
     */
    readonly isRedeemed?: boolean

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListUserTokens
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponsV2ApiListUserTokens
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof CouponsV2ApiListUserTokens
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for setCouponCodeToHasBeenSeen operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiSetCouponCodeToHasBeenSeenRequest
 */
export interface CouponsV2ApiSetCouponCodeToHasBeenSeenRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiSetCouponCodeToHasBeenSeen
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiSetCouponCodeToHasBeenSeen
     */
    readonly userOrderId: string
}

/**
 * Request parameters for updateCouponGift operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiUpdateCouponGiftRequest
 */
export interface CouponsV2ApiUpdateCouponGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiUpdateCouponGift
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiUpdateCouponGift
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiUpdateCouponGift
     */
    readonly couponsV2GiftId: string

    /**
     * 
     * @type {UpdateCouponsV2GiftDTO}
     * @memberof CouponsV2ApiUpdateCouponGift
     */
    readonly updateCouponsV2GiftDTO: UpdateCouponsV2GiftDTO
}

/**
 * Request parameters for updateUserOrder operation in CouponsV2Api.
 * @export
 * @interface CouponsV2ApiUpdateUserOrderRequest
 */
export interface CouponsV2ApiUpdateUserOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiUpdateUserOrder
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof CouponsV2ApiUpdateUserOrder
     */
    readonly userOrderId: string

    /**
     * 
     * @type {UpdateCouponsV2UserOrderDTO}
     * @memberof CouponsV2ApiUpdateUserOrder
     */
    readonly updateCouponsV2UserOrderDTO: UpdateCouponsV2UserOrderDTO
}

/**
 * CouponsV2Api - object-oriented interface
 * @export
 * @class CouponsV2Api
 * @extends {BaseAPI}
 */
export class CouponsV2Api extends BaseAPI {
    /**
     * 
     * @summary cancels a pending token order
     * @param {CouponsV2ApiCancelTokenOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public cancelTokenOrder(requestParameters: CouponsV2ApiCancelTokenOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).cancelTokenOrder(requestParameters.tenantId, requestParameters.couponsV2TokenOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary cancels a pending coupon user order
     * @param {CouponsV2ApiCancelUserOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public cancelUserOrder(requestParameters: CouponsV2ApiCancelUserOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).cancelUserOrder(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary claims the gift for an employee and assigns it to the user
     * @param {CouponsV2ApiClaimCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public claimCouponGift(requestParameters: CouponsV2ApiClaimCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).claimCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates a coupon gift for employee
     * @param {CouponsV2ApiCreateCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public createCouponGift(requestParameters: CouponsV2ApiCreateCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).createCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.createCouponsV2GiftDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deletes a coupon gift for employee
     * @param {CouponsV2ApiDeleteCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public deleteCouponGift(requestParameters: CouponsV2ApiDeleteCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).deleteCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns the whole transaction history list in CSV format
     * @param {CouponsV2ApiExportTokenOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public exportTokenOrders(requestParameters: CouponsV2ApiExportTokenOrdersRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).exportTokenOrders(requestParameters.tenantId, requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupons available to user
     * @param {CouponsV2ApiFindUserCouponDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public findUserCouponDefinitions(requestParameters: CouponsV2ApiFindUserCouponDefinitionsRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).findUserCouponDefinitions(requestParameters.userId, requestParameters.includeVariations, requestParameters.variation, requestParameters.variations, requestParameters.category, requestParameters.includeCombinations, requestParameters.isFallback, requestParameters.isFlexFallback, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon gift by id
     * @param {CouponsV2ApiGetCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public getCouponGift(requestParameters: CouponsV2ApiGetCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).getCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a single token order by id
     * @param {CouponsV2ApiGetTokenOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public getTokenOrder(requestParameters: CouponsV2ApiGetTokenOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).getTokenOrder(requestParameters.tenantId, requestParameters.couponsV2TokenOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon definition for the user
     * @param {CouponsV2ApiGetUserCouponDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public getUserCouponDefinition(requestParameters: CouponsV2ApiGetUserCouponDefinitionRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).getUserCouponDefinition(requestParameters.userId, requestParameters.couponDefinitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single coupon user order by id
     * @param {CouponsV2ApiGetUserOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public getUserOrder(requestParameters: CouponsV2ApiGetUserOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).getUserOrder(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns a single user token by id
     * @param {CouponsV2ApiGetUserTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public getUserToken(requestParameters: CouponsV2ApiGetUserTokenRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).getUserToken(requestParameters.userId, requestParameters.userTokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all coupon orders for all users
     * @param {CouponsV2ApiListAllOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listAllOrders(requestParameters: CouponsV2ApiListAllOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listAllOrders(requestParameters.status, requestParameters.filter, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all budget orders for all tenants
     * @param {CouponsV2ApiListAllTokenOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listAllTokenOrders(requestParameters: CouponsV2ApiListAllTokenOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listAllTokenOrders(requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon gifts for employee
     * @param {CouponsV2ApiListCouponGiftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listCouponGifts(requestParameters: CouponsV2ApiListCouponGiftsRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listCouponGifts(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon gifts for tenant
     * @param {CouponsV2ApiListTenantCouponGiftsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listTenantCouponGifts(requestParameters: CouponsV2ApiListTenantCouponGiftsRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listTenantCouponGifts(requestParameters.tenantId, requestParameters.filter, requestParameters.isDelivered, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns token orders for tenant
     * @param {CouponsV2ApiListTokenOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listTokenOrders(requestParameters: CouponsV2ApiListTokenOrdersRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listTokenOrders(requestParameters.tenantId, requestParameters.month, requestParameters.orderReason, requestParameters.giftType, requestParameters.status, requestParameters.filter, requestParameters.withAggregations, requestParameters.deletedOnly, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns coupon orders for user
     * @param {CouponsV2ApiListUserOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listUserOrders(requestParameters: CouponsV2ApiListUserOrdersRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listUserOrders(requestParameters.userId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns tokens for user
     * @param {CouponsV2ApiListUserTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public listUserTokens(requestParameters: CouponsV2ApiListUserTokensRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).listUserTokens(requestParameters.userId, requestParameters.isRedeemed, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sets coupon code to seen
     * @param {CouponsV2ApiSetCouponCodeToHasBeenSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public setCouponCodeToHasBeenSeen(requestParameters: CouponsV2ApiSetCouponCodeToHasBeenSeenRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).setCouponCodeToHasBeenSeen(requestParameters.userId, requestParameters.userOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a coupon gift for employee
     * @param {CouponsV2ApiUpdateCouponGiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public updateCouponGift(requestParameters: CouponsV2ApiUpdateCouponGiftRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).updateCouponGift(requestParameters.tenantId, requestParameters.employeeId, requestParameters.couponsV2GiftId, requestParameters.updateCouponsV2GiftDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a coupon order for user
     * @param {CouponsV2ApiUpdateUserOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsV2Api
     */
    public updateUserOrder(requestParameters: CouponsV2ApiUpdateUserOrderRequest, options?: RawAxiosRequestConfig) {
        return CouponsV2ApiFp(this.configuration).updateUserOrder(requestParameters.userId, requestParameters.userOrderId, requestParameters.updateCouponsV2UserOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportTokenOrdersOrderReasonEnum = {
    BenefitActivation: 'BENEFIT_ACTIVATION',
    Gift: 'GIFT'
} as const;
export type ExportTokenOrdersOrderReasonEnum = typeof ExportTokenOrdersOrderReasonEnum[keyof typeof ExportTokenOrdersOrderReasonEnum];
/**
 * @export
 */
export const ExportTokenOrdersGiftTypeEnum = {
    Gift: 'GIFT',
    Incentive: 'INCENTIVE'
} as const;
export type ExportTokenOrdersGiftTypeEnum = typeof ExportTokenOrdersGiftTypeEnum[keyof typeof ExportTokenOrdersGiftTypeEnum];
/**
 * @export
 */
export const ExportTokenOrdersStatusEnum = {
    Initial: 'INITIAL',
    InvoiceCreated: 'INVOICE_CREATED',
    Paid: 'PAID',
    Available: 'AVAILABLE',
    Delivered: 'DELIVERED',
    PaymentFailed: 'PAYMENT_FAILED',
    PendingRefund: 'PENDING_REFUND',
    Cancelled: 'CANCELLED'
} as const;
export type ExportTokenOrdersStatusEnum = typeof ExportTokenOrdersStatusEnum[keyof typeof ExportTokenOrdersStatusEnum];
/**
 * @export
 */
export const ListAllTokenOrdersOrderReasonEnum = {
    BenefitActivation: 'BENEFIT_ACTIVATION',
    Gift: 'GIFT'
} as const;
export type ListAllTokenOrdersOrderReasonEnum = typeof ListAllTokenOrdersOrderReasonEnum[keyof typeof ListAllTokenOrdersOrderReasonEnum];
/**
 * @export
 */
export const ListAllTokenOrdersGiftTypeEnum = {
    Gift: 'GIFT',
    Incentive: 'INCENTIVE'
} as const;
export type ListAllTokenOrdersGiftTypeEnum = typeof ListAllTokenOrdersGiftTypeEnum[keyof typeof ListAllTokenOrdersGiftTypeEnum];
/**
 * @export
 */
export const ListAllTokenOrdersStatusEnum = {
    Initial: 'INITIAL',
    InvoiceCreated: 'INVOICE_CREATED',
    Paid: 'PAID',
    Available: 'AVAILABLE',
    Delivered: 'DELIVERED',
    PaymentFailed: 'PAYMENT_FAILED',
    PendingRefund: 'PENDING_REFUND',
    Cancelled: 'CANCELLED'
} as const;
export type ListAllTokenOrdersStatusEnum = typeof ListAllTokenOrdersStatusEnum[keyof typeof ListAllTokenOrdersStatusEnum];
/**
 * @export
 */
export const ListTokenOrdersOrderReasonEnum = {
    BenefitActivation: 'BENEFIT_ACTIVATION',
    Gift: 'GIFT'
} as const;
export type ListTokenOrdersOrderReasonEnum = typeof ListTokenOrdersOrderReasonEnum[keyof typeof ListTokenOrdersOrderReasonEnum];
/**
 * @export
 */
export const ListTokenOrdersGiftTypeEnum = {
    Gift: 'GIFT',
    Incentive: 'INCENTIVE'
} as const;
export type ListTokenOrdersGiftTypeEnum = typeof ListTokenOrdersGiftTypeEnum[keyof typeof ListTokenOrdersGiftTypeEnum];
/**
 * @export
 */
export const ListTokenOrdersStatusEnum = {
    Initial: 'INITIAL',
    InvoiceCreated: 'INVOICE_CREATED',
    Paid: 'PAID',
    Available: 'AVAILABLE',
    Delivered: 'DELIVERED',
    PaymentFailed: 'PAYMENT_FAILED',
    PendingRefund: 'PENDING_REFUND',
    Cancelled: 'CANCELLED'
} as const;
export type ListTokenOrdersStatusEnum = typeof ListTokenOrdersStatusEnum[keyof typeof ListTokenOrdersStatusEnum];
